// DialogProjectTeamAdd component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Avatar from '../../../common/common/avatar/avatar.jsx'
import Dialog from '../../../common/layout/dialog/dialog.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import Input from '../../../common/form/input/input.jsx'
import ContentMessage from '../../../common/common/content_message/content_message.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'

class DialogProjectTeamAdd extends Component {
  constructor (props) {
    super(props)

    this.state = {
      keyword: '',
      selectedOption: null,
      searchOptions: [],
      active: false
    }
  }

  static get propTypes () {
    return {
      onSearch: PropTypes.func,
      onAdd: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      onSearch: null,
      onAdd: null
    }
  }

  show () {
    FabButtonManager.setVisible(false)
    this.setState({ active: true })
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState({
      keyword: '',
      selectedOption: null,
      searchOptions: [],
      active: false
    })
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._onKeyDown)
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._onKeyDown)
  }

  _onKeyDown = (ev) => {
    if (this.state.active && this.state.selectedOption && ev.keyCode === 13) {
      this._onAdd(this.state.selectedOption, ev)
    }
  };

  render () {
    const { selectedOption } = this.state
    return (
      <Dialog
        active={this.state.active}
        onClose={this.hide.bind(this)}
        modal
        hasScroll={false}
        type='medium'
      >
        <div className='dialog-actionboard'>
          <div className='actionboard-section'>
            <div className='actionboard-headavatar'>
              <Avatar imageUrl='/images/common/sample.png' />
            </div>
            {selectedOption && (
              <div className='actionboard-headavatar active'>
                <Avatar
                  imageUrl={selectedOption.imageUrl}
                  title={selectedOption.label}
                />
              </div>
            )}
            <div className='actionboard-search'>
              {selectedOption ? (
                this._renderSelectedOption()
              ) : (
                <form action='#'>
                  <Input
                    type='text'
                    name='keyword'
                    maxLength={100}
                    size={10}
                    label='project.form.teamMember'
                    value={this.state.keyword}
                    prefixIcon='form-search'
                    onChange={this._onSearch.bind(this)}
                  />
                  {this._renderSearchOptions()}
                </form>
              )}
            </div>
          </div>
        </div>
      </Dialog>
    )
  }

  /* Event Handlers */
  _onSelect (option) {
    this.setState({ selectedOption: option })
  }

  _onSearch (keyword) {
    this.setState({ keyword: keyword })
    if (this.props.onSearch) {
      this.props.onSearch(keyword, (options) => {
        this.setState({ searchOptions: options })
      })
    }
  }

  _onAdd (selectedOption, event) {
    event.preventDefault()

    if (this.props.onAdd) {
      this.props.onAdd(selectedOption.value)
      this.hide()
    }
  }

  _onSaveAndAdd (selectedOption, event) {
    event.preventDefault()

    if (this.props.onAdd) {
      this.props.onAdd(selectedOption.value)
      this.setState({
        keyword: '',
        selectedOption: null,
        searchOptions: []
      })
    }
  }

  /* Private Functions */
  _renderSearchOptions () {
    if (this.state.searchOptions && this.state.searchOptions.length > 0) {
      return (
        <div className='actionboard-searchlist'>
          {this.state.searchOptions.map((option) => (
            <div
              key={option.value}
              className='item'
              onClick={this._onSelect.bind(this, option)}
            >
              <Avatar imageUrl={option.imageUrl} title={option.label} />
              <span className='title'>{option.label}</span>
            </div>
          ))}
        </div>
      )
    }

    if (this.state.keyword && this.state.searchOptions.length === 0) {
      return (
        <ContentMessage
          message='project.form.msgErrorTeamAddTitle'
          className='content-message_dialog'
          showAdd={false}
          showAddPrefix={false}
          showAddSuffix={false}
          info='project.form.msgErrorTeamAddContent'
        />
      )
    } else {
      return ''
    }
  }

  _renderSelectedOption () {
    const { selectedOption } = this.state
    return (
      <div className='actionboard-searchselected'>
        <h2 className='title'>{selectedOption.label}</h2>
        <IconButton
          className='dialogsaveadd'
          type='primary'
          size='big'
          icon='common-saveadd'
          title='project.form.tipAddAnotherTeamMember'
          canHover={false}
          onClick={this._onSaveAndAdd.bind(this, selectedOption)}
        />
        <IconButton
          className='dialogadd'
          type='primary'
          size='big'
          icon='common-success-tick'
          title='project.form.tipAddTeamMember'
          canHover={false}
          onClick={this._onAdd.bind(this, selectedOption)}
        />
      </div>
    )
  }
}

export default DialogProjectTeamAdd
